"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('controllers/fourFiveController',["require", "exports", "providers/ajaxSettingsProvider", "controllers/abortingRequest"], function (require, exports, ajaxSettingsProvider, abortingRequest) {
    "use strict";

    var FourFiveController = function () {
        function FourFiveController() {
            _classCallCheck(this, FourFiveController);
        }

        _createClass(FourFiveController, [{
            key: "search",
            value: function search(searchString) {
                return abortingRequest.send('/api/fourfive/search?searchString=' + searchString, ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "user",
            value: function user(userId) {
                return abortingRequest.send('/api/fourfive/user/' + userId, ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "updateUserType",
            value: function updateUserType(userId, currentTypeId) {
                return abortingRequest.send('/api/fourfive/updateUserType/' + userId + '/' + currentTypeId, ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "policy",
            value: function policy(userId) {
                return abortingRequest.send('/api/fourfive/policy/' + userId, ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "tests",
            value: function tests(userId) {
                return abortingRequest.send('/api/fourfive/tests/' + userId, ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "appDetails",
            value: function appDetails(userId) {
                return abortingRequest.send('/api/fourfive/appDetails/' + userId, ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "activities",
            value: function activities(userId) {
                return abortingRequest.send('/api/fourfive/activities/' + userId, ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "communications",
            value: function communications(userId) {
                return abortingRequest.send('/api/fourfive/communications/' + userId, ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "score",
            value: function score(userId, timeFrame) {
                return abortingRequest.send('/api/fourfive/score/' + userId + '/' + timeFrame, ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "ranking",
            value: function ranking(userId, timeFrame) {
                return abortingRequest.send('/api/fourfive/ranking/' + userId + '/' + timeFrame, ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "eligibilityDetails",
            value: function eligibilityDetails(userId) {
                return abortingRequest.send('/api/fourfive/eligibilityDetails/' + userId, ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "dataDrop",
            value: function dataDrop(userId) {
                return abortingRequest.send('/api/fourfive/dataDrop/' + userId, ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "callbacks",
            value: function callbacks(userId) {
                return abortingRequest.send('/api/fourfive/callbacks/' + userId, ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "userAggData",
            value: function userAggData(userId) {
                return abortingRequest.send('/api/fourfive/userAggData/' + userId, ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "getLastUserImport",
            value: function getLastUserImport() {
                return abortingRequest.send('/api/fourfive/GetLastUserImport', ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "getPreviousUserImports",
            value: function getPreviousUserImports(offset, count) {
                return abortingRequest.send('/api/fourfive/GetPreviousUserImports/' + offset + '/' + count, ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "getPreviousUserImport",
            value: function getPreviousUserImport(fileName) {
                return abortingRequest.send('/api/fourfive/GetPreviousUserImport/' + fileName + '/', ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "downloadUserImportFile",
            value: function downloadUserImportFile(fileName) {
                return abortingRequest.send('/api/fourfive/DownloadUserImportFile/' + fileName + '/', ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "validateUserImport",
            value: function validateUserImport(csvFile) {
                var ajaxSettings = ajaxSettingsProvider.httpPost(csvFile);
                ajaxSettings.settings.contentType = false;
                ajaxSettings.settings.processData = false;
                return abortingRequest.send('/api/fourfive/ValidateUserImport', ajaxSettings);
            }
        }, {
            key: "uploadUserImport",
            value: function uploadUserImport(csvFile) {
                var ajaxSettings = ajaxSettingsProvider.httpPost(csvFile);
                ajaxSettings.settings.contentType = false;
                ajaxSettings.settings.processData = false;
                return abortingRequest.send('/api/fourfive/UploadUserImport', ajaxSettings);
            }
        }, {
            key: "getRankings",
            value: function getRankings(data) {
                return abortingRequest.send('/api/fourfive/GetRankings/', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getEligibility",
            value: function getEligibility() {
                return abortingRequest.send('/api/fourfive/GetEligibility/', ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "getUserScores",
            value: function getUserScores(data) {
                return abortingRequest.send('/api/fourfive/GetUserScores/', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getScoreDetails",
            value: function getScoreDetails(data) {
                return abortingRequest.send('/api/fourfive/GetScoreDetails/', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "toggleScoring",
            value: function toggleScoring(data) {
                return abortingRequest.send('/api/fourfive/toggleScoring/', ajaxSettingsProvider.httpPost(data));
            }
        }]);

        return FourFiveController;
    }();

    return new FourFiveController();
});
//# sourceMappingURL=fourFiveController.js.map;
